import { Spinner } from '@/components/ui/spinner';
import { createFileRoute } from '@tanstack/react-router';
import TesteGratisRouteComponent from './-component';
import { testeGratisLoader } from './-loader';
import { parametrosTesteGratisSchema } from './-schemas';

export const Route = createFileRoute('/__public/novo-cliente/')({
  component: RouteComponent,
  loader: testeGratisLoader,
  pendingComponent: () => (
    <div className="flex size-full items-center justify-center">
      <Spinner className="size-12" />
    </div>
  ),
});

function RouteComponent() {
  const search = Route.useSearch();
  const dados = parametrosTesteGratisSchema.parse(search);

  return <TesteGratisRouteComponent dados={dados} />;
}
